var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDeleteloader(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 100 100",
    preserveAspectRatio: "xMidYMid",
    style: {
      shapeRendering: "auto",
      display: "block",
      background: "transparent"
    },
    width: 200,
    height: 200,
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    fill: "#000000",
    r: 10,
    cy: 50,
    cx: 84
  }, /*#__PURE__*/React.createElement("animate", {
    begin: "0s",
    keySplines: "0 0.5 0.5 1",
    values: "10;0",
    keyTimes: "0;1",
    calcMode: "spline",
    dur: "0.5208333333333333s",
    repeatCount: "indefinite",
    attributeName: "r"
  }), /*#__PURE__*/React.createElement("animate", {
    begin: "0s",
    values: "#000000;#000000;#000000;#000000;#000000",
    keyTimes: "0;0.25;0.5;0.75;1",
    calcMode: "discrete",
    dur: "2.083333333333333s",
    repeatCount: "indefinite",
    attributeName: "fill"
  })), /*#__PURE__*/React.createElement("circle", {
    fill: "#000000",
    r: 10,
    cy: 50,
    cx: 16
  }, /*#__PURE__*/React.createElement("animate", {
    begin: "0s",
    keySplines: "0 0.5 0.5 1;0 0.5 0.5 1;0 0.5 0.5 1;0 0.5 0.5 1",
    values: "0;0;10;10;10",
    keyTimes: "0;0.25;0.5;0.75;1",
    calcMode: "spline",
    dur: "2.083333333333333s",
    repeatCount: "indefinite",
    attributeName: "r"
  }), /*#__PURE__*/React.createElement("animate", {
    begin: "0s",
    keySplines: "0 0.5 0.5 1;0 0.5 0.5 1;0 0.5 0.5 1;0 0.5 0.5 1",
    values: "16;16;16;50;84",
    keyTimes: "0;0.25;0.5;0.75;1",
    calcMode: "spline",
    dur: "2.083333333333333s",
    repeatCount: "indefinite",
    attributeName: "cx"
  })), /*#__PURE__*/React.createElement("circle", {
    fill: "#000000",
    r: 10,
    cy: 50,
    cx: 50
  }, /*#__PURE__*/React.createElement("animate", {
    begin: "-0.5208333333333333s",
    keySplines: "0 0.5 0.5 1;0 0.5 0.5 1;0 0.5 0.5 1;0 0.5 0.5 1",
    values: "0;0;10;10;10",
    keyTimes: "0;0.25;0.5;0.75;1",
    calcMode: "spline",
    dur: "2.083333333333333s",
    repeatCount: "indefinite",
    attributeName: "r"
  }), /*#__PURE__*/React.createElement("animate", {
    begin: "-0.5208333333333333s",
    keySplines: "0 0.5 0.5 1;0 0.5 0.5 1;0 0.5 0.5 1;0 0.5 0.5 1",
    values: "16;16;16;50;84",
    keyTimes: "0;0.25;0.5;0.75;1",
    calcMode: "spline",
    dur: "2.083333333333333s",
    repeatCount: "indefinite",
    attributeName: "cx"
  })), /*#__PURE__*/React.createElement("circle", {
    fill: "#000000",
    r: 10,
    cy: 50,
    cx: 84
  }, /*#__PURE__*/React.createElement("animate", {
    begin: "-1.0416666666666665s",
    keySplines: "0 0.5 0.5 1;0 0.5 0.5 1;0 0.5 0.5 1;0 0.5 0.5 1",
    values: "0;0;10;10;10",
    keyTimes: "0;0.25;0.5;0.75;1",
    calcMode: "spline",
    dur: "2.083333333333333s",
    repeatCount: "indefinite",
    attributeName: "r"
  }), /*#__PURE__*/React.createElement("animate", {
    begin: "-1.0416666666666665s",
    keySplines: "0 0.5 0.5 1;0 0.5 0.5 1;0 0.5 0.5 1;0 0.5 0.5 1",
    values: "16;16;16;50;84",
    keyTimes: "0;0.25;0.5;0.75;1",
    calcMode: "spline",
    dur: "2.083333333333333s",
    repeatCount: "indefinite",
    attributeName: "cx"
  })), /*#__PURE__*/React.createElement("circle", {
    fill: "#000000",
    r: 10,
    cy: 50,
    cx: 16
  }, /*#__PURE__*/React.createElement("animate", {
    begin: "-1.5624999999999998s",
    keySplines: "0 0.5 0.5 1;0 0.5 0.5 1;0 0.5 0.5 1;0 0.5 0.5 1",
    values: "0;0;10;10;10",
    keyTimes: "0;0.25;0.5;0.75;1",
    calcMode: "spline",
    dur: "2.083333333333333s",
    repeatCount: "indefinite",
    attributeName: "r"
  }), /*#__PURE__*/React.createElement("animate", {
    begin: "-1.5624999999999998s",
    keySplines: "0 0.5 0.5 1;0 0.5 0.5 1;0 0.5 0.5 1;0 0.5 0.5 1",
    values: "16;16;16;50;84",
    keyTimes: "0;0.25;0.5;0.75;1",
    calcMode: "spline",
    dur: "2.083333333333333s",
    repeatCount: "indefinite",
    attributeName: "cx"
  })), /*#__PURE__*/React.createElement("g", null))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDeleteloader);
export default __webpack_public_path__ + "static/media/deleteloader.4722de7ce70828146f00f65043c48284.svg";
export { ForwardRef as ReactComponent };